module.exports = __webpack_public_path__ + "static/media/home.ae0afd42.webp";